import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { PageHeader, Form, FormGroup, Col, FormControl, Button, ControlLabel } from 'react-bootstrap';
import Card from '../core/Card'
import {Link} from 'react-router-dom';
// SHARED
import {createUser} from '../user/actions'
import Logo from '../core/components/Logo'
import {Redirect} from 'react-router-dom'

class SignupContainer extends React.Component {
  componentDidMount () {
    this.props.query.wfemail && this.setState({email: this.props.query.wfemail})
  }
  state = {
    email: "",
    password: "",
    password_confirmation: "",
    invite_code: "",
    redirectToReferrer: false
  }
  handleChange(e) {
    this.state[e.target.name] = e.target.value
    this.setState(this.state)
  }

  render() {
    const { isFetching, h3, signupErrorMessage, locationSearch, from, handleOnSubmit} = this.props
    return (
  <div className="Authenticate">
    <Card>
      <div className="signup-container">

        <div className="">
          <Form className="credentials-form" onSubmit={(e)=>{
            if (isFetching) return
            // TODO .then if error?
            handleOnSubmit(e, this.state).then((response)=>{
              this.setState({
                email: "",
                password: "",
                password_confirmation: "",
                invite_code: ""
              })
            })

          }} horizontal>
            <Logo />

            <FormGroup controlId="formTitle">
             <Col sm={12}>
               <h3 className="form-title">{h3}</h3>
             </Col>
            </FormGroup>

            <FormGroup controlId="formHorizontalEmail">
             <Col sm={12}>
               <FormControl className="input-lg" type="email" name="email" value={this.state.email} placeholder="Email" onChange={this.handleChange.bind(this)} />

             </Col>
            </FormGroup>

            <FormGroup controlId="formHorizontalPassword">

             <Col sm={12}>
               <FormControl className="input-lg" type="password" name="password" value={this.state.password} placeholder="Password" onChange={this.handleChange.bind(this)} />

             </Col>
            </FormGroup>


            <FormGroup>
             <Col sm={12}>
               <Button disabled={isFetching} className="btn-main-green" bsSize="large" type="submit" >
                {isFetching ? "Signing Up..." : "Sign Up"}
               </Button>

               <div style={{
                   width: "100% ",
                   textAlign: "center",
                   color: "#d02f2f",
                   marginTop: "15px"
               }}>
                 {signupErrorMessage}
               </div>
             </Col>
           </FormGroup>

          <FormGroup>
            <Col className="forgot-password" sm={12}>
              <Link to={{pathname: "/login", search: locationSearch}}>
                Already have an account? Log In
              </Link>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col className="forgot-password" sm={12}>
              By signing up you agree to the <a target="_blank" href="https://everlance.com/terms-of-service">Terms of Service</a>
            </Col>
          </FormGroup>

          </Form>
        </div>
      </div>
    </Card>
</div>
    )
  }
}

export default SignupContainer



// WEBPACK FOOTER //
// ./src/user/SignupContainer.js